import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * グッズ検索パラメータ用クラス
 */
@JsonObject('GoodsGetCondition')
export default class GoodsGetCondition {
  constructor() {
    this.needFee = undefined;
  }

  @JsonProperty('need_fee', null, true)
  public needFee?: boolean;
}
